// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3ej-k","right":"styles_right__10ZAf"};